import PropTypes from 'prop-types';

export default PropTypes.shape({
  primary: PropTypes.string,
  tease: PropTypes.string,
  seo: PropTypes.string,
  social: PropTypes.string,
});
